export default "__VITE_ASSET__BCkj$uZH__"